import { useCallback } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../services/authService';

type ThemeMode = 'light' | 'dark' | 'system';

/**
 * Applies a theme at once and saves it to the account, so the choice follows the user to other
 * devices and the app (T-128). A failed save keeps the choice on this device.
 */
export const useThemeChoice = (): ((mode: ThemeMode) => void) => {
  const { setMode } = useTheme();
  const { updateUser } = useAuth();
  return useCallback((mode: ThemeMode) => {
    setMode(mode);
    authService.updateProfile({ themePreference: mode })
      .then(updatedUser => updateUser(updatedUser))
      .catch(() => { /* the device keeps the choice (localStorage) */ });
  }, [setMode, updateUser]);
};
